export default __webpack_public_path__ + "static/media/payment-plan-deposit-two-two.77017ccb.png";